import Repository from "./Repository";

const resource = "/bo/articles";
export default {
  /**
   * Fetch articles from API
   * Search option not reuquired
   * @param {string} product_model Product model ex MOLDED_SEAT
   * @param {string} search_term Search term
   */
  fetchArticles(product_model, search_term = null) {
    // Returns all articles
    if (!search_term) {
      return Repository.get(`${resource}?product_model=${product_model}`);
    }

    // Returns article by search
    return Repository.get(
      `${resource}?product_model=${product_model}&search=${search_term}`
    );
  }
};
